import { partnerLogosCarousel } from '../components/partner-logos-carousel';

partnerLogosCarousel('#partners-logos');